import * as React from 'react'
import * as styles from './style/index.scss';
import {FormattedMessage} from 'react-intl'

const DotTitle = ({messageId}) => (
    <p className={styles.packageTitle}><span className={styles.dot}/>
        <FormattedMessage id={messageId}/>
    </p>
)

export default DotTitle
